import { en } from './translation_en';
import { ar } from './translation_ar';

// Common constants
export const STRING_CONSTANTS = {
  COMMON: {
    MODE: {
      ADD: 'add',
      EDIT: 'edit',
      VIEW: 'view',
    },
    PAGE_NOT_FOUND_TEXT: 'Page Not Found',
    UNAUTHORIZED_TEXT: 'Unauthorized',
    NOT_FOUND_CODE: '404',
    UNAUTHORIZED_CODE: '401',
  },
  LABELS: {
    CHECKING_AUTHENTICATION: 'Checking authentication...',
    LOADING: 'Loading...',
    EMAIL_ADDRESS: 'Email Address',
    PASSWORD: 'Password',
    REMEMBER_ME: 'Remember me',
    ENGLISH: 'English',
    ARABIC: 'Arabic',
    BACK_TO_LOGIN: 'Back to Login',
    FORGOT_PASSWORD: 'Forgot Password?',
    SEND_RESET_LINK: 'Send Reset Link',
    SENDING: 'Sending...',
    CHANGING: 'Changing...',
    NEW_PASSWORD: 'New Password',
    CURRENT_PASSWORD: 'Current Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    ENTER_NEW_PASSWORD_BELOW: 'Enter your new password below',
    VIEW: 'View',
    EDIT: 'Edit',
    DELETE: 'Delete',
    LOGOUT: 'Logout',
    LOGIN: 'Login',
    OTP_VERIFY: 'OTP Verify',
    VERIFY: 'Verify',
    RESENDING: 'Resending...',
    RESEND_OTP: 'Resend OTP',
    RESEND_CODE_IN: 'Resend code in',
    SELECT_AN_OPTION: 'Select an option',
    NO_OPTIONS_FOUND: 'No options found',
  },
  PLACEHOLDERS: {
    EMAIL: 'Enter your email',
    PASSWORD: 'Enter your password',
    CURRENT_PASSWORD: 'Enter current password',
    NEW_PASSWORD: 'Enter new password',
    CONFIRM_NEW_PASSWORD: 'Confirm new password',
  },
  MODAL_TITLES: {
    CHANGE_PASSWORD: 'Change Password',
  },
  STORED_KEYS: {
    ACCESS_TOKEN: 'access_token',
    AUTH_TOKEN: 'authToken',
    USER: 'user',
    USER_DETAILS: 'userDetails',
    USER_MENU: 'userMenu',
    LOGIN_CREDENTIALS: 'login_credentials',
  },
  MESSAGES: {
    ERROR: {
      GENERIC: 'An error occurred. Please try again.',
      GENERIC_WITH_DETAILS: 'An error occurred',
      NETWORK_ERROR: 'Network error. Please check your connection and try again.',
      UNAUTHORIZED: 'Please login to continue',
      FETCH_FAILED: 'Failed to fetch data. Please try again.',
      OTP_SEND_FAILED: 'Failed to send OTP. Please try again.',
      OTP_RESEND_FAILED: 'Failed to resend OTP. Please try again.',
      OTP_INVALID: 'Invalid OTP. Please try again.',
      OTP_CREDENTIALS_REQUIRED: 'Email and password are required to resend OTP',
      SAVE_FAILED: 'Failed to save',
      UPDATE_FAILED: 'Failed to update',
      DELETE_FAILED: 'Failed to delete',
      LOGOUT_ERROR: 'Failed to logout',
      UNABLE_TO_RETRIEVE_EMAIL: 'Unable to retrieve email',
      PASSWORD_CHANGE_FAILED: 'Failed to change password',
    },
    SUCCESS: {
      SAVE_SUCCESS: 'Saved successfully',
      UPDATE_SUCCESS: 'Updated successfully',
      DELETE_SUCCESS: 'Deleted successfully',
      OTP_SENT: 'OTP sent successfully',
      OTP_VERIFIED: 'OTP verified successfully',
      OTP_SENT_EMAIL: 'OTP sent to your email',
      PASSWORD_CHANGED: 'Password changed successfully',
    },
    VALIDATION: {
      EMAIL_REQUIRED: 'Email is required',
      EMAIL_INVALID: 'Invalid email address',
      INVALID_EMAIL: 'Invalid email address',
      OTP_INCOMPLETE: 'Please enter complete OTP',
      CURRENT_PASSWORD_REQUIRED: 'Current password is required',
      NEW_PASSWORD_REQUIRED: 'New password is required',
      PASSWORD_MIN_LENGTH: 'Password must be at least 6 characters',
      CONFIRM_PASSWORD_REQUIRED: 'Please confirm your password',
      PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
    },
    CONFIRMATION: {
      DELETE_ITEM: (name) => `Are you sure you want to delete ${name}?`,
    },
  },

  FORM_TYPES: {
    TEXT: 'text',
    EMAIL: 'email',
    PASSWORD: 'password',
    NUMBER: 'number',
    DATE: 'date',
    SELECT: 'select',
  },

  EXPORT: {
    FILENAMES: {
      CATEGORY: 'category',
      SERVICE: 'service',
      COMPLAIN: 'issue_categories',
      DEPARTMENT: 'department',
      PROVIDER: 'provider',
    },
    TITLES: {
      CATEGORY_LIST: 'Category List',
      SERVICE_LIST: 'Service List',
      COMPLAIN_LIST: 'Issue Categories List',
      DEPARTMENT_LIST: 'Department List',
      PROVIDER_LIST: 'Provider List',
    },
  },

  SORT: {
    ORDER: {
      ASC: 'ASC',
      DESC: 'DESC',
    },
    FIELDS: {
      ID: 'id',
      NAME: 'name',
      CREATED_AT: 'created_at',
    },
  },
  API_FIELDS: {
    CATEGORY: {
      ID: 'id',
      NAME: 'category_name',
      CREATED_AT: 'created_at',
    },
    SERVICE: {
      ID: 'id',
      NAME: 'service_name',
      CREATED_AT: 'created_at',
    },
    COMPLAIN: {
      ID: 'id',
      ISSUE_EN: 'issue_en',
      ISSUE_AR: 'issue_ar',
      CREATED_AT: 'created_at',
    },
    DEPARTMENT: {
      ID: 'id',
      NAME: 'department_name',
      CREATED_AT: 'created_at',
    },
    PROVIDER: {
      ID: 'id',
      NAME: 'provider_name',
      CREATED_AT: 'created_at',
    },
    ROLE: {
      ID: 'id',
      NAME: 'name',
      CREATED_AT: 'created_at',
    },
  },

  AUTH: {
    WELCOME_BACK: 'Welcome Back',
    SIGN_IN_CONTINUE: 'Sign in to continue to your account',
    FORGOT_PASSWORD_TITLE: 'Forgot Password?',
    FORGOT_PASSWORD_SUBTITLE: "No worries, we'll send you reset instructions.",
    ENTER_OTP: 'Enter OTP',
    OTP_SENT_TO: "We've sent a 6-digit code to",
    SHOW_PASSWORD: 'Show password',
    HIDE_PASSWORD: 'Hide password',
  },

  BRAND: {
    SHOPPING_GATE: 'ShoppingGate',
    SHOPPING_GATE_LOGO: 'ShoppingGate Logo',
    SHOPPING_GATE_MERCHANT: 'SG Customer Support',
    MERCHANT_PANEL: 'SG Customer Support',
    DASHBOARD: 'Dashboard',
    CATEGORY: 'Category',
    SERVICE: 'Service',
    DEPARTMENT: 'Department',
    ROLE: 'Role',
    TICKETS: 'Tickets',
    COMPLAIN: 'Issue Categories',
    CUSTOMERS: 'Customers',
    USER_MANAGEMENT: 'User Management',
    SETTINGS: 'Settings',
    PROFILE: 'Profile',
  },

  TRANSLATIONS: {
    en,
    ar,
  },
};

export { ROUTE_CONSTANTS } from './routeConstants';
